const CPC_GET_EMAIL_AND_MTN = 'CPC_GET_EMAIL_AND_MTN';
const CPC_GET_EMAIL_AND_MTN_SUCCESS = 'CPC_GET_EMAIL_AND_MTN_SUCCESS';
const CPC_GET_EMAIL_AND_MTN_FAIL = 'CPC_GET_EMAIL_AND_MTN_FAIL';
const CPC_GEN_INSPICIO_ID = 'CPC_GEN_INSPICIO_ID';
const CPC_GEN_INSPICIO_ID_SUCCESS = 'CPC_GEN_INSPICIO_ID_SUCCESS';
const CPC_GEN_INSPICIO_ID_FAIL = 'CPC_GEN_INSPICIO_ID_FAIL';
const CPC_SEND_SMS_EMAIL_INSPICIO = 'CPC_SEND_SMS_EMAIL_INSPICIO';
const CPC_SEND_SMS_EMAIL_INSPICIO_SUCCESS = 'CPC_SEND_SMS_EMAIL_INSPICIO_SUCCESS';
const CPC_SEND_SMS_EMAIL_INSPICIO_FAIL = 'CPC_SEND_SMS_EMAIL_INSPICIO_FAIL';
const CPC_INITIAL_STATE = 'CPC_INITIAL_STATE';
const CPC_INSPECIO_FORGET_PIN = 'CPC_INSPECIO_FORGET_PIN';
const CPC_INSPECIO_SHOWFORGETPIN_SUCCESS = 'CPC_INSPECIO_SHOWFORGETPIN_SUCCESS';
const CPC_INSPECIO_SHOWFORGETPIN_FAIL = 'CPC_INSPECIO_SHOWFORGETPIN_FAIL';
const CPC_INSP_VERIFY_PIN = 'CPC_INSP_VERIFY_PIN';
const CPC_VALIDATE_PIN = 'CPC_VALIDATE_PIN';
const CPC_VALIDATE_PIN_SUCCESS = 'CPC_VALIDATE_PIN_SUCCESS';
const CPC_VALIDATE_PIN_FAIL = 'CPC_VALIDATE_PIN_FAIL';
const CPC_RESEND_EMAIL_MTN_FLAGS = 'CPC_RESEND_EMAIL_MTN_FLAGS';
const CPC_SEND_OTP_EMAIL = 'CPC_SEND_OTP_EMAIL';
const CPC_SEND_OTP_EMAIL_SUCCESS = 'CPC_SEND_OTP_EMAIL_SUCCESS';
const CPC_SEND_OTP_EMAIL_FAIL = 'CPC_SEND_OTP_EMAIL_FAIL';
const CPC_VERIFY_EMAIL = 'CPC_VERIFY_EMAIL';
const CPC_VERIFY_EMAIL_AUTH_CODE = 'CPC_VERIFY_EMAIL_AUTH_CODE';
const EMAIL_OTP_SEND_MSG_AUTH_TRIGGER = 'EMAIL_OTP_SEND_MSG_AUTH_TRIGGER';
const EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_SUCCESS = 'EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_SUCCESS';
const EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_FAIL = 'EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_FAIL';
const EMAIL_VALIDATE_OTP = 'EMAIL_VALIDATE_OTP';
const EMAIL_VALIDATE_OTP_SUCCESS = 'EMAIL_VALIDATE_OTP_SUCCESS';
const EMAIL_VALIDATE_OTP_FAIL = 'EMAIL_VALIDATE_OTP_FAIL';
const EMAIL_OTP_SEND_MSG_AUTH_TEXT = 'EMAIL_OTP_SEND_MSG_AUTH_TEXT';
const EMAIL_OTP_SEND_MSG_AUTH_TEXT_SUCCESS = 'EMAIL_OTP_SEND_MSG_AUTH_TEXT_SUCCESS';
const EMAIL_OTP_SEND_MSG_AUTH_TEXT_FAIL = 'EMAIL_OTP_SEND_MSG_AUTH_TEXT_FAIL';
const CPC_ACCEPT_PLANS = 'CPC_ACCEPT_PLANS';
const CPC_PLANS_CONFIRMATION = 'CPC_PLANS_CONFIRMATION';
const CPC_PLANS_CONFIRMATION_SUCCESS = 'CPC_PLANS_CONFIRMATION_SUCCESS';
const CPC_PLANS_CONFIRMATION_FAIL = 'CPC_PLANS_CONFIRMATION_FAIL';
const CPC_CBAND_QUALIFICATION = 'CPC_CBAND_QUALIFICATION';
const CPC_CBAND_QUALIFICATION_SUCCESS = 'CPC_CBAND_QUALIFICATION_SUCCESS';
const CPC_CBAND_QUALIFICATION_FAIL = 'CPC_CBAND_QUALIFICATION_FAIL';
const CPC_GETPLANS = 'CPC_GET_PLANS';
const CPC_GETPLANS_SUCCESS = 'CPC_GET_PLANS_SUCCESS';
const CPC_GETPLANS_FAIL = 'CPC_GET_PLANS_FAIL';
const CPC_UPDATECART = 'CPC_UPDATECART';
const CPC_UPDATECART_SUCCESS = 'CPC_UPDATECART_SUCCESS';
const CPC_UPDATECART_FAIL = 'CPC_UPDATECART_FAIL';
const CPC_INSPECIO_GETPLANS = 'CPC_INSPECIO_GETPLANS';
const CPC_INSPECIO_GETPLANS_SUCCESS = 'CPC_INSPECIO_GETPLANS_SUCCESS';
const CPC_INSPECIO_GETPLANS_FAIL = 'CPC_INSPECIO_GETPLANS_FAIL';
const CPC_INSPECIO_VALIDATEPIN = 'CPC_INSPECIO_VALIDATEPIN';
const CPC_INSPECIO_VALIDATEPIN_SUCCESS = 'CPC_INSPECIO_VALIDATEPIN_SUCCESS';
const CPC_INSPECIO_VALIDATEPIN_FAIL = 'CPC_INSPECIO_VALIDATEPIN_FAIL';
const CPC_PLANS_SUBMIT = 'CPC_PLANS_SUBMIT';
const CPC_PLANS_SUBMIT_SUCCESS = 'CPC_PLANS_SUBMIT_SUCCESS';
const CPC_PLANS_SUBMIT_FAIL = 'CPC_PLANS_SUBMIT_FAIL';
const CPC_RETRIEVE_CART = 'CPC_RETRIEVE_CART';
const CPC_RETRIEVE_CART_SUCCESS = 'CPC_RETRIEVE_CART_SUCCESS';
const CPC_RETRIEVE_CART_FAIL = 'CPC_RETRIEVE_CART_FAIL';
const CPC_DECLINE_PLANS_UPDATE = 'CPC_DECLINE_PLANS_UPDATE';
const CPC_SEND_DECLINE_PLANS = 'CPC_SEND_DECLINE_PLANS';
const CPC_SEND_DECLINE_PLANS_SUCCESS = 'CPC_SEND_DECLINE_PLANS_SUCCESS';
const CPC_SEND_DECLINE_PLANS_FAIL = 'CPC_SEND_DECLINE_PLANS_FAIL';
const CPC_SEND_ERROR_MESSAGE = 'CPC_SEND_ERROR_MESSAGE';
const CPC_SEND_ERROR_MESSAGE_SUCCESS = 'CPC_SEND_ERROR_MESSAGE_SUCCESS';
const CPC_SEND_ERROR_MESSAGE_FAIL = 'CPC_SEND_ERROR_MESSAGE_FAIL';
const CPC_ORDER_CONFIRMATION = 'CPC_ORDER_CONFIRMATION';
const MTN_EMAIL_RESPONSE = 'MTN_EMAIL_RESPONSE';

export {
  CPC_GET_EMAIL_AND_MTN,
  CPC_GET_EMAIL_AND_MTN_SUCCESS,
  CPC_GET_EMAIL_AND_MTN_FAIL,
  CPC_GEN_INSPICIO_ID,
  CPC_GEN_INSPICIO_ID_SUCCESS,
  CPC_GEN_INSPICIO_ID_FAIL,
  CPC_SEND_SMS_EMAIL_INSPICIO,
  CPC_SEND_SMS_EMAIL_INSPICIO_SUCCESS,
  CPC_SEND_SMS_EMAIL_INSPICIO_FAIL,
  CPC_INITIAL_STATE,
  CPC_INSPECIO_FORGET_PIN,
  CPC_INSPECIO_SHOWFORGETPIN_FAIL,
  CPC_VALIDATE_PIN,
  CPC_VALIDATE_PIN_FAIL,
  CPC_RESEND_EMAIL_MTN_FLAGS,
  CPC_INSPECIO_SHOWFORGETPIN_SUCCESS,
  CPC_INSP_VERIFY_PIN,
  CPC_VALIDATE_PIN_SUCCESS,
  CPC_SEND_OTP_EMAIL,
  CPC_SEND_OTP_EMAIL_SUCCESS,
  CPC_SEND_OTP_EMAIL_FAIL,
  CPC_VERIFY_EMAIL,
  CPC_VERIFY_EMAIL_AUTH_CODE,
  EMAIL_OTP_SEND_MSG_AUTH_TRIGGER,
  EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_SUCCESS,
  EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_FAIL,
  EMAIL_VALIDATE_OTP,
  EMAIL_VALIDATE_OTP_SUCCESS,
  EMAIL_VALIDATE_OTP_FAIL,
  EMAIL_OTP_SEND_MSG_AUTH_TEXT,
  EMAIL_OTP_SEND_MSG_AUTH_TEXT_SUCCESS,
  EMAIL_OTP_SEND_MSG_AUTH_TEXT_FAIL,
  CPC_ACCEPT_PLANS,
  CPC_PLANS_CONFIRMATION,
  CPC_PLANS_CONFIRMATION_SUCCESS,
  CPC_PLANS_CONFIRMATION_FAIL,
  CPC_GETPLANS,
  CPC_GETPLANS_SUCCESS,
  CPC_GETPLANS_FAIL,
  CPC_UPDATECART,
  CPC_UPDATECART_SUCCESS,
  CPC_UPDATECART_FAIL,
  CPC_INSPECIO_GETPLANS,
  CPC_INSPECIO_GETPLANS_SUCCESS,
  CPC_INSPECIO_GETPLANS_FAIL,
  CPC_INSPECIO_VALIDATEPIN,
  CPC_INSPECIO_VALIDATEPIN_SUCCESS,
  CPC_INSPECIO_VALIDATEPIN_FAIL,

  CPC_PLANS_SUBMIT,
  CPC_PLANS_SUBMIT_SUCCESS,
  CPC_PLANS_SUBMIT_FAIL,
  CPC_RETRIEVE_CART,
  CPC_RETRIEVE_CART_SUCCESS,
  CPC_RETRIEVE_CART_FAIL,
  CPC_DECLINE_PLANS_UPDATE,
  CPC_SEND_DECLINE_PLANS,
  CPC_SEND_DECLINE_PLANS_SUCCESS,
  CPC_SEND_DECLINE_PLANS_FAIL,
  CPC_SEND_ERROR_MESSAGE,
  CPC_SEND_ERROR_MESSAGE_SUCCESS,
  CPC_SEND_ERROR_MESSAGE_FAIL,
  CPC_CBAND_QUALIFICATION,
  CPC_CBAND_QUALIFICATION_SUCCESS,
  CPC_CBAND_QUALIFICATION_FAIL,
  CPC_ORDER_CONFIRMATION,
  MTN_EMAIL_RESPONSE,
};
